import { useId } from 'react';
import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import { useSetExperienceVisibility } from '@/features/permissions/hooks/useSetExperienceVisibility';
import { Role } from '@/types/gql.generated';
import { Flex, FormControl, FormLabel, Switch, Text, useToast } from '@/ui';

export const PublicLinkToggle = () => {
  const id = useId();
  const { experience } = usePageExperienceContext();
  // Owner-only server-side, which is why this isn't part of updateExperience.
  const { setVisibility } = useSetExperienceVisibility();
  const toast = useToast();

  const isPublic = experience?.isPublic ?? false;
  // Publishing is the owner's decision. A collaborator still sees the switch and its
  // state, read-only, but can't flip it — the same split CopyLinkSection uses for the
  // custom URL.
  const isOwner = experience?.role === Role.Owner;

  // The switch is optimistic, so a refusal silently snaps it back and reads as the
  // click not registering. Say so instead, the way the sibling access control does.
  const handleMutationError = () =>
    toast.error('Could not update link sharing');

  return (
    <Flex direction="column" gap="2">
      <FormControl alignItems="center" display="flex">
        <FormLabel fontWeight="medium" htmlFor={id} lineHeight="normal" mb="0">
          Anyone with the link can view
        </FormLabel>
        <Switch
          colorScheme="purple"
          id={id}
          isChecked={isPublic}
          isDisabled={!isOwner}
          ml="auto"
          onChange={() =>
            setVisibility(!isPublic, { onError: handleMutationError })
          }
        />
      </FormControl>

      {!isOwner && (
        <Text color="ink.muted" fontSize="ah-status">
          Only the owner can change this.
        </Text>
      )}
    </Flex>
  );
};
